module.exports = __webpack_public_path__ + "static/media/GT-Alpina-Regular-Italic.f38e54a1.ttf";